export class Controller {

    /** @ngInject */
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
    }

    templateUrl() {
        return require(`./what-is-sms-service-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/what-is-sms-service/what-is-sms-service.controller.js